
import { EventImageRounded } from "./EventImageRounded";
import { EventImageSquare } from "@/components/shared/EventImageSquare";

interface EventImageProps {
  image?: string | null;
  title: string;
  rounded?: boolean;
  eventImages?: Array<{
    image_id: string;
    image_url: string;
    is_primary: boolean;
    display_order: number;
  }> | null;
}

export const EventImage = ({ image, title, rounded = true, eventImages }: EventImageProps) => {
  return rounded ? 
    <EventImageRounded image={image} title={title} eventImages={eventImages} /> : 
    <EventImageSquare image={image} title={title} eventImages={eventImages} />;
};
